module.exports = __webpack_public_path__ + "img/alipay.f9c1a5a0.svg";